export const faqs = [
  {
    id: "faq-01",
    question: "瓜友会网的爆料多久更新一次？",
    answer:
      "热门话题基本保持实时滚动更新，通常在事件出现后的两到四小时内补齐时间线与多方说法。日常时段每小时会做一次整体刷新，夜间也会有值班编辑跟进突发进展。",
  },
  {
    id: "faq-02",
    question: "内容里的说法可以完全相信吗？",
    answer:
      "我们尽量还原已公开的信息，并在有争议时标注多方口径。但爆料类内容本身存在不确定性，建议把这里当作梳理线索的起点，而不是最终结论，重要判断请以官方回应为准。",
  },
  {
    id: "faq-03",
    question: "怎么快速找到某个圈层的瓜？",
    answer:
      "首页可以直接切换圈层分类，也可以从顶部导航进入对应分类页。分类页支持按热度或最新排序，想系统性地看一个话题，可以顺着文章末尾的相关推荐继续往下读。",
  },
  {
    id: "faq-04",
    question: "我可以自己投稿爆料吗？",
    answer:
      "可以。在关于我们页面找到投稿表单，填写你想分享的线索即可。为了确保可信度，建议附上大致时间、可公开求证的信息来源。我们会在核实后决定是否整理成文。",
  },
  {
    id: "faq-05",
    question: "网站会不会泄露投稿人的信息？",
    answer:
      "投稿表单中除邮箱外不收集任何身份信息，昵称可以随意填写。我们不会公开任何投稿来源，也不会把联系方式用于内容之外的用途。",
  },
];